
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/priority-support",
      function () {
        return require("private-next-pages/priority-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/priority-support"])
      });
    }
  